import { ref, type Ref } from "vue";
import type { FormFieldDefinition, FormFieldInstance, FormFieldReferenceAttributes } from "./field";

export type UseFormFieldProps<ValueType = any> = {
  schema: FormFieldDefinition<any, ValueType>;
  onChange?: (value: ValueType) => void;
  transform?: (value: ValueType) => ValueType;
}
export type UseFormField<ValueType = any> = {
  dataRef: FormFieldInstance<ValueType>;
}

export const useFormField = <ValueType = any>(props: UseFormFieldProps<ValueType>): UseFormField<ValueType> => {
  const fieldValue = ref<ValueType>(props.schema.value as unknown as any as ValueType) as unknown as any as Ref<ValueType>;
  const attributes = ref<FormFieldReferenceAttributes<any, any>>(props.schema) as unknown as any as Ref<FormFieldReferenceAttributes<any, any>> ;
  const focused = ref<boolean>(false);
  const touched = ref<boolean>(false);
  const instance: FormFieldInstance<ValueType> = {
    ...props.schema,
    attributes: attributes,
    value: fieldValue,
    setValue: (nextValue) => {
      if (props.transform) {
        nextValue = props.transform(nextValue);
      }

      fieldValue.value = nextValue;
      if (props.onChange) {
        props.onChange(nextValue);
      }
    },
    markChanged: () => {
      // Mark field as changed
    },
    setFocused: (focus) => {
      focused.value = focus;
    },
    setTouched: (touch) => {
      touched.value = touch;
    },
  }


  return { dataRef: instance };
}
